<template>

    <header>
        <!--<div @click="changeMiniVariant()"></div>-->
        <div class="container-logo">
            <img class="header-logo" src="../../assets/img/logo.png">
        </div>
        <div class="container-avatar">
            <div class="avatar"></div>
            <div class="menu_admin">
                <ul>
                    <li @click="logout()">Logout</li>
                </ul>

            </div>
        </div>

    </header>

</template>




<script>

    import { mapGetters } from 'vuex'

    export default {
        name: 'Header',
        methods: {

            changeMiniVariant () {
                this.$store.dispatch('changeMiniVariant')
            },

            logout () {
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.replace("/login")
                    })
            },

        },
        computed: {
            ...mapGetters(['miniVariant'])
        },

    }
</script>

